import * as React from "react";
import { Helmet } from "react-helmet";
import get from "lodash/get";
import { graphql, useStaticQuery } from "gatsby";

const Metadata = ({ metadata }) => {
  const [canonicalTag, setCanonicalTag] = React.useState("");

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      let path = window.location.pathname;
      const tempString = window.location.pathname.substring(0, 4);
      if (tempString === "/si/" || tempString === "/ta/") {
        setCanonicalTag(path.replace(tempString, "/"));
      } else {
        setCanonicalTag(path);
      }
    }
  }, []);

  const defaultMetadata = useStaticQuery(graphql`
    query {
      prismicGlobalData(lang: { eq: "en-us" }) {
        data {
          meta_description
          meta_title
          meta_image {
            url
          }
        }
      }
    }
  `);

  const defaultMetaTitle = get(
    defaultMetadata,
    "prismicGlobalData.data.meta_title",
    "Welcome to Insure Me"
  );

  const defaultMetaDescription = get(
    defaultMetadata,
    "prismicGlobalData.data.meta_description",
    "Welcome to Insure Me"
  );

  const defaultMetaImage = get(
    defaultMetadata,
    "prismicGlobalData.data.meta_image.url",
    ""
  );

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>
        {get(metadata, "metaTitle", defaultMetaTitle) || defaultMetaTitle}
      </title>
      <meta
        name="google-site-verification"
        content="wrmDBxzmREGSBtLSR63BsccKj_RgKTN-t9jsydTbZ-o"
      />
      <meta
        name="description"
        content={
          get(metadata, "metaDescription", defaultMetaDescription) ||
          defaultMetaDescription
        }
      />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta
        property="og:image"
        content={
          get(metadata, "metaImage.url", defaultMetaImage) || defaultMetaImage
        }
      />

      <meta name="og:title" content={get(metadata, "facebookTitle", "")} />
      <meta
        name="og:description"
        content={get(metadata, "facebookDescription", "")}
      />
      <meta
        name="og:image"
        content={
          get(metadata, "metaImage.url", defaultMetaImage) || defaultMetaImage
        }
      />

      <meta name="twitter:card" content="summary_large_image" />

      <meta
        name="twitter:image"
        content={
          get(metadata, "metaImage.url", defaultMetaImage) || defaultMetaImage
        }
      />
      <meta
        name="twitter:description"
        content={get(metadata, "twitterDescription", "")}
      />
      <meta name="twitter:title" content={get(metadata, "twitterTitle", "")} />

      <link rel="canonical" href={`https://insureme.lk${canonicalTag}`} />
    </Helmet>
  );
};

export default Metadata;
